import createId from "~/kernel/random/createId";

const STORAGE_KEY = "analyticsSessionId";

export default function getAnalyticsSessionId(
  storage: Storage = sessionStorage,
) {
  const existing = storage.getItem(STORAGE_KEY);

  if (existing) {
    return existing;
  }

  const sessionId = createId();
  storage.setItem(STORAGE_KEY, sessionId);

  return sessionId;
}
